import { useMutation, useQueryClient } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useUpdateResultsChallenge = () => {
  const queryClient = useQueryClient();
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async ({ challengeId, step, score, isValidation, note, attachedFile }) => {
      // Costruisce il FormData con i campi richiesti
      const formData = new FormData();
      
      // Aggiunge step (campo obbligatorio)
      formData.append('step', step);
      
      // Aggiunge i campi opzionali solo se forniti
      if (score !== undefined && score !== null) {
        formData.append('score', score);
      }
      if (isValidation !== undefined && isValidation !== null) {
        formData.append('isValidation', isValidation);
      }
      if (note) {
        formData.append('note', note);
      }
      
      if (attachedFile) {
        formData.append('attachedFile', attachedFile);
      }

      const result = await restClient({
        url: `${prefix}/results/challenge/${challengeId}`,
        method: 'PUT',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return result;
    },
    onSuccess: () => {
      // Invalidate and refetch challenge results after successful update
      queryClient.invalidateQueries({ queryKey: ['resultsChallenge'] });
    },
    onError: () => {
    },
  });
};
